import { Link } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import styles from './Breadcrumbs.module.css'

export const Breadcrumbs = ({ breadcrumbs }) => {
  const items = breadcrumbs.map((item) => ({
    title: item.href ? (
      <Link to={item.href} className={`${styles.breadcrumb_item_link} ${styles.breadcrumb_item}`}>
        {item.label}
      </Link>
    ) : (
      <span className={styles.breadcrumb_item}>{item.label}</span>
    )
  }))

  return (
    <div className={styles.wrapper}>
      <Breadcrumb className={styles.breadcrumb} items={items} />
    </div>
  )
}
